module.exports = function anonymous(it
/**/) {
var out='<source src="'+(it.SrcWebm)+'" type="video/webm"><source src="'+(it.SrcMp4)+'" type="video/mp4">';return out;
}


//////////////////
// WEBPACK FOOTER
// ./source/scripts/templates/htmlVideo.dot
// module id = 239
// module chunks = 0 1